import { cn } from '@dfh-corp-sites/ui/utils'
import React, { useEffect } from 'react'

import { SanityDisclaimerModule } from '../../../graphql/gatsby'
import { setAnalyticsEvent } from '../../../lib/analytics/state'

const DisclaimerModule: React.FC<SanityDisclaimerModule> = ({
  title,
  firstColumnTitle,
  tableTitle,
  content,
  firstColumnContent,
  items,
}) => {
  useEffect(() => {
    setAnalyticsEvent({
      _key: 'DisclaimerModule',
      event: 'select_content',
      content_type: 'disclaimer',
      item_id: 'DisclaimerModule',
      title: title || '',
      label_text: firstColumnTitle || '',
      module_name: 'DisclaimerModule',
    })
  }, [title, firstColumnTitle])

  if (!items) return null

  const half = Math.ceil(items.length / 2)
  const firstHalf = items.slice(0, half)
  const secondHalf = items.slice(half)

  return (
    <div
      className={cn([
        'w-full bg-white text-[#656565]',
        'py-[60px]',
        'px-6 md:px-12 xl:px-[60px]',
        'max-w-[1280px] mx-auto',
      ])}
    >
      <div className={cn(['flex flex-col gap-10', 'lg:flex-row', 'md:flex-col'])}>
        <div className={cn(['w-full max-w-full', 'lg:max-w-[305px]'])}>
          <label className={cn(['text-sm font-medium text-[#656565]'])}>{title}</label>

          <p className="whitespace-pre-line mt-5 text-sm text-[#65656] leading-[170%] font-normal">
            {content}
          </p>
        </div>

        <div className={cn('w-full')}>
          <div className="max-w-[550px] mb-6">
            <label className="font-medium text-sm">{tableTitle}</label>
          </div>

          <div className={cn(['grid grid-cols-1 text-xs leading-[150%]', 'md:grid-cols-3'])}>
            <div className="flex flex-col h-full">
              <div className="border-t border-l border-r p-2 font-medium border-brand-rule-grey">
                {firstColumnTitle}
              </div>

              <div
                className={cn([
                  'col-start-1 row-start-2 row-span-full',
                  'border-brand-rule-grey border p-2 h-full',
                  'flex items-center',
                ])}
              >
                {firstColumnContent}
              </div>
            </div>

            <div className="flex flex-col">
              {firstHalf?.map((item, index) => (
                <div
                  key={index}
                  className={cn([
                    'border-brand-rule-grey border-b border-r p-2',
                    index === 0 ? 'border-t' : '',
                  ])}
                >
                  {item}
                </div>
              ))}
            </div>

            <div className="flex flex-col">
              {secondHalf?.map((item, index) => (
                <div
                  key={index}
                  className={cn([
                    'border-brand-rule-grey border-b border-r p-2',
                    index === 0 ? 'border-t' : '',
                  ])}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { DisclaimerModule }
